import React, { PropsWithChildren, useEffect, useState } from 'react';
import { Box, SxProps } from '@mui/material';
import { Checkbox } from '@europrocurement/flexy-components';
import { DisplayedDocument } from '../../../providers/types';
import DocumentItem from '../DocumentItem/DocumentItem';

type DocumentsSelectorsFormProps = {
    preSelectedDocumentsIds: number[];
    documents: DisplayedDocument[];
    setSelectedDocuments: React.Dispatch<React.SetStateAction<DisplayedDocument[]>>;
    sxWrapper?: SxProps;
};

const DocumentsSelectorsForm: React.FunctionComponent<
    PropsWithChildren<DocumentsSelectorsFormProps>
> = function ({ preSelectedDocumentsIds, documents, setSelectedDocuments, sxWrapper, children }) {
    const [selectedDocumentsIds, setSelectedDocumentsIds] = useState<number[]>([]);

    // Select ou remove selected document
    const handleSelectDocument = (doc: DisplayedDocument) => {
        if (doc.documentTypeId) {
            if (selectedDocumentsIds.includes(doc.documentTypeId)) {
                setSelectedDocumentsIds((state) => state.filter((id) => id !== doc.documentTypeId));
                setSelectedDocuments((docsState) =>
                    docsState.filter((docState) => docState.id !== doc.id),
                );
            } else {
                setSelectedDocumentsIds((state) => [...state, doc.documentTypeId as number]);
                setSelectedDocuments((docs) => [...docs, doc]);
            }
        }
    };

    // Automatically pre-check documents based on preSelectedDocumentsProps
    useEffect(() => {
        if (preSelectedDocumentsIds) {
            setSelectedDocumentsIds(preSelectedDocumentsIds);
            // Hydrate selectedDocuments
            setSelectedDocuments(
                documents.filter(
                    (doc) =>
                        doc.documentTypeId && preSelectedDocumentsIds.includes(doc.documentTypeId),
                ),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [preSelectedDocumentsIds]);

    return (
        <Box
            sx={{
                padding: '0',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px 0',
                maxHeight: '55vh',
                overflow: 'auto',
                ...sxWrapper,
            }}
        >
            {documents.map((doc) => (
                <Box
                    key={doc.id}
                    sx={{ display: 'flex', width: '100%', alignItems: 'center' }}
                >
                    <Checkbox
                        checked={
                            doc.documentTypeId
                                ? selectedDocumentsIds.includes(doc.documentTypeId)
                                : false
                        }
                        onChange={() => doc.documentTypeId && handleSelectDocument(doc)}
                    />
                    <DocumentItem
                        {...doc}
                        sx={{ width: '100%', position: 'relative' }}
                        actionWrapperSxProps={{ display: 'none' }}
                    />
                </Box>
            ))}
            {children}
        </Box>
    );
};

export default DocumentsSelectorsForm;
